export default __webpack_public_path__ + "staticlp1/media/credit-card-elo.77d62455.png";